import {BaseFormModel} from './base-form-model';

export class SalesReportSummary extends BaseFormModel<SalesReportSummary> {
    tabCount: number;
    sales: number;
    taxes: number;
    credits: number;
    tips: number;
}
